
import { BalanceController } from "@/app/ui/controllers/BalanceController";
import { Options, Vue } from "vue-class-component";
import formatPrice from "@/app/infrastructures/misc/common-library/FormatPrice";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { AuthController } from "@/app/ui/controllers/AuthController";
import debounce from "lodash/debounce";
import MaskedPasswordInput from "@/app/ui/views/cod-income/components/masked-password-input.vue";
import WithdrawalAmountInput from "@/app/ui/views/cod-income/components/withdrawal-amount-input.vue";
import SidebarSubmitWithdraw from "@/app/ui/views/cod-income/components/sidebar-submit-withdraw.vue";
import { BalanceDetailData } from '@/domain/entities/BalanceLimit';
import { container } from 'tsyringe';
import { BalanceLimitPresenter } from '@/app/ui/presenters/BalanceLimitPresenter';

@Options({
  components: {
    MaskedPasswordInput,
    WithdrawalAmountInput,
    SidebarSubmitWithdraw
  }
})
class CodIncomeWithdraw extends Vue {
  passwordType = "password";
  iconType = "eye";
  password = "";
  isPasswordValidate = false;
  private passwordRequestId = 0;

  withdrawalAmount = 0;
  isAmountError = false;
  limitDetail: BalanceDetailData | null = null;
  isLimitLoaded = false;

  mounted() {
    this.loadWithdrawLimit();
  }

  get accountType() {
    if (AccountController.accountData.account_type === "partner") {
      return AccountController.accountData.account_type_detail.type;
    }
    return AccountController.accountData.account_type;
  }

  get balance() {
    return BalanceController.balanceData.walletBalanceCod;
  }

  get countryCode() {
    const code = AccountController.accountData?.countryCode;
    return code?.toUpperCase() ?? "ID";
  }

  get isWrongPassword() {
    return AuthController.isErrorWrongPassword;
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  get isReadyToSubmit() {
    return (
      this.withdrawalAmount > 0 &&
      !this.isAmountError &&
      this.isPasswordValidate
    );
  }

  get minAmount(): number {
    const d: any = this.limitDetail;
    const value =
      this.countryCode === "MY"
        ? d?.minimumWithdrawAmountMY
        : d?.minimumWithdrawAmount;
    return Number(value) || 0;
  }

  get minBalanceLimit(): number {
    const d: any = this.limitDetail;
    const value = this.countryCode === "MY" ? d?.minBalanceMY : d?.minBalance;
    return Number(value) || 0;
  }

  get maxAmount(): number {
    return Number(Math.max(this.balance, 0).toFixed(3));
  }

  get isInputDisabled(): boolean {
    return !this.isLimitLoaded || this.maxAmount <= 0;
  }

  formatPrice(val: any) {
    const currency = this.countryCode === "MY" ? "MYR" : "IDR";
    return formatPrice(val, "", currency);
  }

  goBack() {
    this.$router.push("/cod-income");
  }

  showPassword() {
    if (this.passwordType === "password" && this.iconType === "eye") {
      this.passwordType = "text";
      this.iconType = "eye-slash";
    } else {
      this.passwordType = "password";
      this.iconType = "eye";
    }
  }

  onPasswordChange = debounce(async (value: string) => {
    if (value.length === 0) {
      AuthController.setErrorPassword(false);
      this.isPasswordValidate = false;
      this.passwordRequestId++;
      return;
    }

    const currentRequestId = ++this.passwordRequestId;

    const isValid = await AuthController._onCheckPassword({
      email: this.dataProfile.username || this.dataProfile.email,
      password: value
    });

    if (currentRequestId !== this.passwordRequestId) return;

    this.isPasswordValidate = isValid;
  }, 500);

  async loadWithdrawLimit() {
    try {
      const presenter = container.resolve(BalanceLimitPresenter);

      const list = await presenter.getBalanceList(1, 10);
      const rule = list.data.find(
        (r: any) =>
          r.status?.toLowerCase() === "active" &&
          r.appliedTo.toLowerCase() === this.accountType
      );
      if (!rule) return;

      this.limitDetail = await presenter.getBalanceDetail(rule.id);
      this.isLimitLoaded = true;
    } catch (e) {
      this.isLimitLoaded = false;
    }
  }
}
export default CodIncomeWithdraw;
